import { createSelector } from '@reduxjs/toolkit'
import { getCalcInputState, getCalcOutputState } from '../../../../utils/selectors'

export const getUIState = (state) => state.ui

export const getActiveTab = (state) => getUIState(state).activeTab
export const getInputErrors = (state) => getUIState(state).inputErrors

export const getJobSettingsState = (state) => getCalcInputState(state).jobSettings
export const getSettingsState = (state) => getCalcInputState(state).settings
export const getWallState = (state) => getCalcInputState(state).wall
export const getRoofState = (state) => getCalcInputState(state).roof

export const getResultState = (state) => getCalcOutputState(state).result
export const getResultQuery = (state) => getResultState(state).query

export const getPrintState = createSelector(
  getSettingsState,
  getJobSettingsState,
  getWallState,
  getRoofState,
  (settings, jobSettings, wall, roof) => ({
    settings: {
      applicationType: wall.applicationType,
      country: settings.country,
    },
    jobSettings,
    wall,
    roof,
  }),
)

const getResultData = (state) => getResultState(state).data
const getResultLoading = (state) => getResultState(state).loading

export const getResult = createSelector(getResultData, getResultLoading, (data, loading) => ({
  data,
  loading,
}))
